if (!customElements.get("auth-modal")) {
  customElements.define(
    "auth-modal",
    class AuthModal extends HTMLElement {
      connectedCallback() {
        document.addEventListener("DOMContentLoaded", () => {
          window.openAuthModal = (panel) => {
            const tabId = panel === "signup" ? "auth-tab-signup" : panel === "recovery" ? "auth-tab-recovery" : "auth-tab-login";
            document.querySelectorAll(".open-login-modal").forEach((btn) => {
              if (tabId === "auth-tab-login") btn.click();
            });
            document.dispatchEvent(new CustomEvent("auth-modal:open", { detail: { tabId } }));
          };
        });
      }
    }
  );
}
document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector("auth-modal")) {
    document.body.appendChild(document.createElement("auth-modal"));
  }
});
